import { render, staticRenderFns } from "./valmistumispyynnon-tila-koulutettava.vue?vue&type=template&id=75ca9d58&scoped=true&"
import script from "./valmistumispyynnon-tila-koulutettava.vue?vue&type=script&lang=ts&"
export * from "./valmistumispyynnon-tila-koulutettava.vue?vue&type=script&lang=ts&"
import style0 from "./valmistumispyynnon-tila-koulutettava.vue?vue&type=style&index=0&id=75ca9d58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ca9d58",
  null
  
)

export default component.exports